import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useAuth } from '../hooks/useAuth';
import Wordmark from './Wordmark';

export default function AppHeader() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const { logout } = useAuth();

  const handleSignOut = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const name = user ? `${user.firstName} ${user.lastName}`.trim() || user.email : '';

  return (
    <header className="border-b border-line bg-surface">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4">
        <Link to="/" aria-label="MerchantView home">
          <Wordmark />
        </Link>
        <div className="flex items-center gap-4">
          <span className="text-caption text-ink-muted">
            Signed in as <span className="font-semibold text-ink">{name}</span>
          </span>
          <Link to="/account/password" className="text-caption font-semibold text-navy underline-offset-4 hover:underline">
            Change password
          </Link>
          <button type="button" className="btn-secondary" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
